import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Trust() {
  const testimonials = [{
    quote: 'Switched to Strata Creative Group last year and saved over $2,000 on our crew uniforms. The quality is bulletproof.',
    author: 'Mike T.',
    role: 'Landscaping Company Owner'
  }, {
    quote: "Fastest turnaround we've ever had. The custom polos and hats look incredible and our staff loves them.",
    author: 'Sarah L.',
    role: 'School Administrator'
  }];
  return <section className="py-24 bg-black text-white" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-149">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-150">
            Trusted by Businesses That Don't Settle
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto font-medium" data-id="element-151">
            From restaurants and construction crews to landscapers, gyms,
            schools, and small businesses — we've printed millions of pieces
            over 30+ years.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-152">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-neutral-900 border-2 border-neutral-800 p-8" data-id="element-153">
              <div className="flex gap-1 mb-6" data-id="element-154">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-white text-white" data-id="element-155" />)}
              </div>
              <p className="text-xl font-medium mb-6 leading-relaxed" data-id="element-156">
                "{t.quote}"
              </p>
              <div data-id="element-157">
                <p className="font-display font-bold uppercase tracking-wider text-lg" data-id="element-158">
                  {t.author}
                </p>
                <p className="text-gray-400" data-id="element-159">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}